'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$67() {
  this.blU = null;
  this.blV = false;
}
export { $c_Lpresto_PrestoRouter$$anon$67 as $c_Lpresto_PrestoRouter$$anon$67 };
$p = $c_Lpresto_PrestoRouter$$anon$67.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$67;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$67() {
}
export { $h_Lpresto_PrestoRouter$$anon$67 as $h_Lpresto_PrestoRouter$$anon$67 };
$h_Lpresto_PrestoRouter$$anon$67.prototype = $p;
$p.P = (function() {
  if ((!this.blV)) {
    this.blU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.blV = true;
  }
  return this.blU;
});
var $d_Lpresto_PrestoRouter$$anon$67 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$67, "presto.PrestoRouter$$anon$67", ({
  OA: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$67 as $d_Lpresto_PrestoRouter$$anon$67 };
//# sourceMappingURL=presto.-Presto-Router$$anon$67.js.map
